module.exports = __webpack_public_path__ + "img/Linkedin.f8e29df9.svg";